import {
	listCampaignBanners,
	createCampaignBanner,
	getCampaignBannerById,
	updateCampaignBanner,
	deleteCampaignBanner,
	approveCampaignBanner,
	rejectCampaignBanner,
	renewCampaignBanners,
} from '@/services/agency/campaigns-banners.service'

export default {
	namespaced: true,
	state: {
		bannerList: { data: [], meta: { pagination: { total: 0 } } },
		banner: {},
		bannerStatus: 'init',
		bannerSaveStatus: 'init',
		bannerDeleteStatus: 'init',
		bannerApprovalStatus: 'init',
		bannerRenewStatus: 'init',
	},
	getters: {
		getBannerList(state) {
			return state.bannerList
		},
		getBanner(state) {
			return state.banner
		},
		getBannerStatus(state) {
			return state.bannerStatus
		},
		getBannerSaveStatus(state) {
			return state.bannerSaveStatus
		},
		getBannerDeleteStatus(state) {
			return state.bannerDeleteStatus
		},
		getBannerApprovalStatus(state) {
			return state.bannerApprovalStatus
		},
		getBannerRenewStatus(state) {
			return state.bannerRenewStatus
		},
	},
	mutations: {
		SET_BANNER_LIST(state, value) {
			state.bannerList = value
		},
		SET_BANNER(state, value) {
			state.banner = value
		},
		SET_BANNER_STATUS(state, value) {
			state.bannerStatus = value
		},
		SET_BANNER_SAVE_STATUS(state, value) {
			state.bannerSaveStatus = value
		},
		SET_BANNER_DELETE_STATUS(state, value) {
			state.bannerDeleteStatus = value
		},
		SET_BANNER_APPROVAL_STATUS(state, value) {
			state.bannerApprovalStatus = value
		},
		SET_BANNER_RENEW_STATUS(state, value) {
			state.bannerRenewStatus = value
		},
	},
	actions: {
		async fetchBanners({ commit }, params) {
			commit('SET_BANNER_STATUS', 'pending')
			try {
				const { data } = await listCampaignBanners(params)
				commit('SET_BANNER_LIST', data)
				commit('SET_BANNER_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_BANNER_STATUS', 'error')
				throw error
			}
		},
		async fetchBannerById({ commit }, id) {
			commit('SET_BANNER_STATUS', 'pending')
			try {
				const { data } = await getCampaignBannerById(id)
				commit('SET_BANNER', data)
				commit('SET_BANNER_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_BANNER_STATUS', 'error')
				throw error
			}
		},
		async saveBanner({ commit }, params) {
			commit('SET_BANNER_SAVE_STATUS', 'pending')
			try {
				const { data } = await createCampaignBanner(params)
				commit('SET_BANNER_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_BANNER_SAVE_STATUS', 'error')
				throw error
			}
		},
		async updateBanner({ commit }, params) {
			commit('SET_BANNER_SAVE_STATUS', 'pending')
			try {
				const { data } = await updateCampaignBanner(params)
				commit('SET_BANNER_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_BANNER_SAVE_STATUS', 'error')
				throw error
			}
		},
		async deleteBanner({ commit }, id) {
			commit('SET_BANNER_DELETE_STATUS', 'pending')
			try {
				const { data } = await deleteCampaignBanner(id)
				commit('SET_BANNER_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_BANNER_DELETE_STATUS', 'error')
				throw error
			}
		},
		async approveBanner({ commit }, id) {
			commit('SET_BANNER_APPROVAL_STATUS', 'pending')
			try {
				const { data } = await approveCampaignBanner(id)
				commit('SET_BANNER_APPROVAL_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_BANNER_APPROVAL_STATUS', 'error')
				throw error
			}
		},
		async rejectBanner({ commit }, { id, reason }) {
			commit('SET_BANNER_APPROVAL_STATUS', 'pending')
			try {
				const { data } = await rejectCampaignBanner(id, reason)
				commit('SET_BANNER_APPROVAL_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_BANNER_APPROVAL_STATUS', 'error')
				throw error
			}
		},
		async renewBanners({ commit }, ids) {
			commit('SET_BANNER_RENEW_STATUS', 'pending')
			try {
				const { data } = await renewCampaignBanners(ids)
				commit('SET_BANNER_RENEW_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_BANNER_RENEW_STATUS', 'error')
				throw error
			}
		},
	},
}
